<template>
  <div class="article-exam-wrapper">
    <div class="article-exam-wrap" ref="wrap">
      <template v-if="isScenePlaying">
        <div class="time" v-if="isExam">{{time}}</div>
        <van-quizzes-controller
            ref="controller"
            :is-exam="isExam"
            :exercises="newQuizzes"
            :user-answer="userAnswer"
            @change="handleChange"
            @finish="handleFinished"
            @exerciseChange="exerciseChange"
        />
      </template>
      <van-exam-list
        v-if="isSceneExamList"
        :results="results"
        ref="examList" />
      <van-article-exam-detail
        v-if="isSceneComparison"
        :before-exam-id="beforeExamId"
        :results="results" />
    </div>
    <van-answer-card
      class="answer-card"
      v-if="isShowAnswerCard"
      :is-exam="isSceneFinished"
      :show-detail="false"
      :show-tagline="false"
      :is-show-hint="isLearnAfterTest"
      :title="navigation"
      :score="score"
      :total="results.length"
      :results="results">
      <div class="detail" :class="{ 'exam-detail': isSceneFinished }" slot="detail">
        <div class="item" v-for="(item, index) in answerCardData" :key="index">
          <div class="tag">
            <el-tag plain size="small">{{quizName[item.code][item.mode]}}</el-tag>
          </div>
          <span class="number"
                :class="{
                  filled: results[answer.index].isComplete,
                  success: results[answer.index].isRight && isSceneFinished,
                  danger: !results[answer.index].isRight && isSceneFinished,
                }"
                @click="selectExercise(answer.index)"
                v-for="(answer, number) in item.quizzes"
                :index="number"
                :global-index="getGlobalQuizIndex(index, number)"
                :key="answer.index">{{number + 1}}</span>
        </div>
      </div>
    </van-answer-card>
    <van-footer-bar
      class="exam-control"
      v-if="isExam"
      :is-exam="isExam"
      :is-show-replay="isShowReplay"
      :is-show-bottom-control="true"
      :is-show-tip="false"
      :is-show-answer-card="isShowAnswerCard"
      :total="results.length"
      :current="exerciseIndex"
      :currentExercise="currentExercise"
      :scene="scene"
      :results="results"
      @replay="replay"
      @finished="finishedExam"
      @submit="handleSubmitExamBtn"
      @back="backFinishedScene"
      :finishedText="finishedText"
      @detail="detail"
      @clear="clear"
      @prev="prev"
      @next="next">
      <div
        class="footer-button-wrapper"
        slot="foot">
        <el-button
          v-if="score === 100 && isLearnBeforeTest"
          type="primary"
          @click="openCertificate">
          查看奖状
        </el-button>
        <el-button
          v-if="isShowNextUnitButton"
          @click="learnNext"
          type="primary">学习下一单元</el-button>
      </div>
    </van-footer-bar>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import {
  RadioButton,
  Button,
  Tag,
} from 'element-ui';
import VanQuizzesController from '@/components/quizzes/bkw/EnglishQuizzes.vue';
import VanFooterBar from '@/components/common/FooterBar.vue';
import VanAnswerCard from '@/components/common/AnswerCard.vue';
import VanExamList from '@/components/quizzes/bkw/ExamDetail.vue';
import VanArticleExamDetail from '@/components/quizzes/bdc/ArticleExamDetail.vue';
import utils from '@/services/utils';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
  examList: 4,
  comparison: 5,
});

export default {
  components: {
    ElRadioButton: RadioButton,
    VanQuizzesController,
    VanFooterBar,
    VanAnswerCard,
    ElButton: Button,
    ElTag: Tag,
    VanExamList,
    VanArticleExamDetail,
  },
  props: {
    navigation: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
    },
    learnMode: {
      type: String,
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    quizzes: {
      type: Array,
      default: () => ([]),
    },
    status: {
      type: Number,
      default: 0,
    },
    time: {
      type: String,
      default: '00:00',
    },
    preScene: {
      type: Number,
      default: 2,
    },
  },
  inject: ['getUnitList', 'getCurrentUnitId'],
  data() {
    return {
      quizName: {
        CHXZ: {
          1: '词汇选择（选解释）',
          2: '词汇选择（选单词）',
          3: '听音选词',
          4: '听音选义',
        },
        DX: {
          0: '单项选择',
        },
        HYDC: {
          0: '还原单词',
        },
        DCTX: {
          0: '单词听写',
        },
        SK: {
          1: '闪卡练习（学习模式）',
          2: '闪卡练习（抄写模式）',
          3: '闪卡练习（录音模式）',
        },
        HYDX: {
          0: '还原单词',
        },
        DCPX: {
          1: '单词拼写（随机模式）',
          2: '单词拼写（默写模式）',
          3: '单词拼写（自定义模式）',
        },
        TYLJ: {
          0: '听音连句',
        },
        BQWZ: {
          0: '补全文章',
        },
        JXZH: {
          0: '句型转换',
        },
        QHLJ: {
          1: '强化炼句（简单模式）',
          2: '强化炼句（复杂模式）',
          3: '强化炼句（默写模式）',
          4: '强化炼句（自定义模式）',
        },
        YDLJ: {
          0: '阅读理解',
        },
        XCTK: {
          0: '选词填空',
        },
        THXZ: {
          0: '听后选择',
        },
        WXTK: {
          0: '完形填空',
        },
      },
      scene: SCENE.playing,
      result: [],
      seconds: 0,
      mode: '', // replay 错题再练
      newQuizzes: [],
      results: [],
      answerCardData: [],
      score: 0,
      currentExercise: {},
      exerciseIndex: 0,
      errMsg: '',
      errCode: 0,
      isContinue: false, // 是否继续人机对话 (当人机对话出现多个)
      isShowAnswerCard: false,
      beforeExamId: 0,
    };
  },
  computed: {
    isExam() {
      return true;
    },
    isShowNextUnitButton() {
      if (this.getUnitList && this.getCurrentUnitId) {
        const unitList = this.getUnitList();
        const currentUnitId = this.getCurrentUnitId();
        const index = utils.Array.findIndex(unitList, { id: currentUnitId }, 'id');
        const isLast = index >= unitList.length - 1;
        return !isLast && this.isLearnBeforeTest && this.score >= 100;
      }
      return false;
    },
    isSceneFinished() {
      return this.scene === SCENE.finished;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    isShowReplay() {
      return !(this.score === 100 || this.isLearnBeforeTest);
    },
    isSceneExamList() {
      return this.scene === SCENE.examList;
    },
    isLearnBeforeTest() {
      return this.learnMode === 'learn_before_test';
    },
    isLearnAfterTest() {
      return this.learnMode === 'learn_after_test';
    },
    finishedText() {
      return this.isLearnBeforeTest ? '继续学习' : '下一步';
    },
    isSceneComparison() {
      return this.scene === SCENE.comparison;
    },
    userAnswer() {
      if (this.results[this.exerciseIndex] && this.isExam) {
        return this.results[this.exerciseIndex].userAnswer || null;
      }
      return null;
    },
  },
  watch: {
    quizzes: {
      handler() {
        this.reset();
        this.newQuizzes = utils.clone(this.quizzes);
        this.results = utils.clone(this.quizzes.map((item, index) => {
          const userAnswer = {};
          item.items.forEach((ele) => {
            userAnswer[ele.id] = ele.wrongAnswer;
          });
          return {
            ...item,
            index,
            isRight: false,
            userAnswer,
            isComplete: false,
          };
        }));
        this.handleAnswerCardData();
      },
      immediate: true,
    },
  },
  methods: {
    startLearn() {
      this.scene = SCENE.playing;
    },
    showComparisonDetail() {
      this.scene = SCENE.comparison;
      this.isShowAnswerCard = false;
    },
    exerciseChange({ id, exerciseIndex = 0 }) {
      this.currentExercise = utils.Array.find(this.newQuizzes, { id }, 'id') || {};
      this.exerciseIndex = exerciseIndex;
    },
    handleAnswerCardData() {
      this.answerCardData = [];
      let quiz = this.results[0];
      let site = 0;
      if (quiz) {
        this.answerCardData[site] = {
          code: quiz.code,
          mode: quiz.mode,
          quizzes: [quiz],
        };
      }
      this.results.forEach((item, index) => {
        if (index > 0) {
          if (item.code === quiz.code && item.mode === quiz.mode) {
            this.answerCardData[site].quizzes.push(item);
          } else {
            site += 1;
            quiz = item;
            this.answerCardData[site] = {
              code: item.code,
              mode: item.mode,
              quizzes: [item],
            };
          }
        }
      });
    },
    handleChange(payload) {
      this.results.forEach((item) => {
        if (item.id === payload.id && item.code === payload.code && item.mode === payload.mode) {
          item.isRight = payload.isRight;
          item.isComplete = payload.isComplete;
          item.userAnswer = utils.clone(payload.userAnswer);
        }
      });
      utils.Array.pushReplace(this.result, payload, 'id');
    },
    backFinishedScene() {
      this.scene = SCENE.finished;
      this.isShowAnswerCard = true;
    },
    handleFinished() {
      this.submit();
    },
    submitExam() {
      // 将大题分解成小题提交 与之前不同 这里需要以小题计算分数
      const results = [];
      this.results.forEach((result) => {
        result.items.forEach((item) => {
          if (result.userAnswer && result.userAnswer[item.id]) {
            results.push({
              id: item.id,
              status: result.userAnswer[item.id] === item.answer ? 1 : 0,
              answer: result.userAnswer[item.id],
            });
          } else {
            results.push({
              id: item.id,
              status: 0,
              answer: '',
            });
          }
        });
      });

      this.quizzes.forEach((item) => {
        item.items.forEach((ele) => {
          const isExist = utils.Array.exist(results, ele, 'id');
          if (!isExist) {
            results.push({
              id: ele.id,
              status: 1,
              answer: ele.answer,
            });
          }
        });
      });

      const emitted = (isRetry) => {
        this.$emit('submit', {
          results,
          callback: ({ score, isContinue, beforeExamId }) => {
            this.beforeExamId = beforeExamId;
            this.isContinue = isContinue;
            this.score = score;
            if (isRetry) {
              this.scene = SCENE.finished;
            }
          },
        });
      };

      this.retry = () => {
        emitted(true);
      };

      emitted();
    },
    replay() {
      let results = utils.clone(this.results);
      // 错题重练 找出错题
      results.forEach((item) => {
        if (item.userAnswer) {
          for (let i = 0; i < item.items.length; i += 1) {
            const element = item.items[i];
            const isRight = element.answer === item.userAnswer[element.id];
            if (isRight) {
              utils.Array.remove(item.items, element, 'id');
              i -= 1;
            }
          }
        }
      });
      results = results.filter(item => item.items.length);
      this.newQuizzes = utils.clone(results);
      this.newQuizzes.forEach((item, index) => {
        const quiz = utils.Array.find(this.quizzes, item, 'id');

        item.isRight = false;
        item.userAnswer = null;
        item.isComplete = false;
        item.index = index;

        if (quiz) {
          item.article = quiz.article;
        }
      });
      this.results = utils.clone(this.newQuizzes);
      this.handleAnswerCardData();
      this.isShowAnswerCard = false;
      this.exerciseIndex = 0;
      this.mode = 'replay';
      this.$emit('replay');
      this.startLearn();
    },
    finishedExam() {
      this.isShowAnswerCard = false;
      this.$emit('finished');
    },
    reset({ scene = SCENE.playing } = {}) {
      this.scene = scene;
      this.result = [];
      this.exerciseIndex = 0;
      this.mode = '';
    },
    getGlobalQuizIndex(index, offset) {
      return this.answerCardData
        .slice(0, index)
        .reduce((pre, cur) => pre.concat(cur.quizzes), [])
        .length + offset;
    },
    selectExercise(index) {
      if (this.isSceneFinished) {
        if (this.isLearnBeforeTest) {
          utils.message('学前测无法查看，做完学后测再来看吧！');
          return;
        }
        this.scene = SCENE.examList;
        this.$nextTick(() => {
          this.setAnchor(index);
        });
      } else {
        this.$refs.controller.exerciseIndex = index;
      }
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    handleSubmitExamBtn() {
      this.submitExam();
      this.scene = SCENE.finished;
      if (this.isLearnAfterTest) {
        const text = '<span style="line-height: 30px">快去看看作答详情吧，精品解析、中英文对照以及外教朗读帮助你更快理解文章！</span>';
        utils.alert(text, '温馨提示', {
          confirmButtonText: '查看',
          customClass: 'tips-dialog',
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            if (action === 'confirm') {
              this.selectExercise(0);
            }
          },
        });
      }
    },
    setAnchor(index) {
      const { code } = this.results[index];
      this.$refs.examList.setAnchor(index, {
        autoPlay: code !== 'THXZ',
      });
      this.isShowAnswerCard = false;
    },
    detail() {
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    prev() {
      this.$refs.controller.prev();
    },
    next(type) {
      this.$refs.controller.next(type);
      this.$nextTick(() => {
        this.$refs.wrap.scrollTop = 0;
      });
    },
    clear() {
      this.$refs.controller.clear();
    },
    handleGlobalEnter(event) {
      if (this.isShowAnswerCard) return;
      if (event.keyCode === 13 && this.isExam) {
        const obj = event.target || event.srcElement; // 获取事件源
        const type = obj.type || obj.getAttribute('type');
        this.next(type);
      }
    },
    bindEnterEvent() {
      document.addEventListener('keyup', this.handleGlobalEnter);
    },
    unBindEnterEvent() {
      document.removeEventListener('keyup', this.handleGlobalEnter);
    },
    openCertificate() {
      this.$emit('openCertificate');
    },
    learnNext() {
      this.$emit('learnNext');
    },
  },
  created() {
    this.retry = () => {};
    this.scene = this.preScene;
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .article-exam-wrapper {
    position: relative;
    height: 100%;
    .article-exam-wrap {
      height: 100%;
      overflow-y: auto;
      .time {
        position: absolute;
        top: 10px;
        right: 0;
        transform: translateX(-50%);
        font-size: 22px;
        color: $primary;
      }
      .finished {
        height: 100%;
      }
      .tip-line {
        margin-top: 20px;
      }
    }
    .exam-control {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      padding: 5px 20px;
      width: 100%;
      /deep/ .button-wrap {
        display: flex;
        .footer-button-wrapper {
          button {
            margin: 0 10px 0 0;
          }
        }
      }
    }
    .answer-card {
      .detail {
        margin-top: -20px;
        padding: 0 40px 20px;
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 158px);
        overflow-y: auto;
        .item {
          width: 100%;
          padding-bottom: 5px;
          border-bottom: 1px solid #eee;
          text-align: left;
          .tag {
            margin: 20px 0 5px 10px;
            text-align: left;
          }
          .number {
            cursor: pointer;
            display: inline-block;
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            margin: 10px;
            font-weight: bold;
            border-radius: 50%;
            color: $primary;
            border: 1px solid $primary;
            &.filled {
              color: #fff;
              background-color: $primary;
            }
            &.danger {
              color: #fff;
              background-color: $danger;
              border: 1px solid $danger;
            }
            &.success {
              color: #333;
              background-color: #b8dfff;
              border: 1px solid #b8dfff;
            }
          }
        }
      }
      .exam-detail {
        height: calc(100% - 315px);
      }
    }
  }
</style>
